import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeleteDlgData } from '../../shared.models';

@Component({
    selector: 'liebherr-delete-dialog',
    templateUrl: 'delete-dialog.component.html',
    styleUrls: ['delete-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteDialogComponent {
    constructor(public dialogRef: MatDialogRef<DeleteDialogComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: DeleteDlgData) {}

    onCancel() {
        this.dialogRef.close(false);
    }
    onSubmit() {
        this.dialogRef.close(true);
    }
}
